// =============================================
// Authentication & User Types
// =============================================

export interface User {
  id: string;
  firstName: string;
  lastName: string;
  email?: string | null;
  phone: string | null;
  role: 'CUSTOMER' | 'ADMIN' | 'OPERATOR';
  isEmailVerified?: boolean;
  isPhoneVerified?: boolean;
  walletBalance?: number;
  hasPassword?: boolean;
  isActive?: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface LoginRequest {
  identifier: string;
  password: string;
}

export interface RegisterRequest {
  firstName: string;
  lastName: string;
  email?: string;
  phone: string;
  /** Omitted for OTP-only sign-ups — those accounts log in by SMS. */
  password?: string;
  emailOtpCode?: string;
  phoneVerificationToken?: string;
}

export interface AuthResponse {
  access_token: string;
  refresh_token: string;
  expires_in: number;
  user: User;
  isNew?: boolean;  // Present in social-login responses; absent in email/password login
  walletCreated?: boolean;  // Present in register responses; false if wallet setup failed
}

export interface AuthState {
  user: User | null;
  token: string | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  error: string | null;
}

// Computed full name helper
export const getUserFullName = (user: User): string => {
  return `${user.firstName} ${user.lastName}`.trim();
};
